"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchIconButton = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgIcon_1 = __importDefault(require("@atg/icf-react-components/components/SvgIcon"));
var react_jss_1 = require("react-jss");
var useSearchIconButtonStyles = (0, react_jss_1.createUseStyles)({
    thumbnailButton: {
        marginInlineStart: 16,
        padding: 0,
        border: "none",
        background: "none",
        cursor: "pointer",
        outline: "none",
    },
});
var SearchIconButton = function (props) {
    var fill = props.fill, iconName = props.iconName, onClick = props.onClick, iconSize = props.iconSize;
    var classes = useSearchIconButtonStyles();
    return ((0, jsx_runtime_1.jsx)("button", { className: classes.thumbnailButton, onClick: onClick, children: (0, jsx_runtime_1.jsx)(SvgIcon_1.default, { size: iconSize, name: iconName, fill: fill }) }));
};
exports.SearchIconButton = SearchIconButton;
exports.SearchIconButton.displayName = "SearchIconButton";
//# sourceMappingURL=SearchIconButton.js.map